<template>
    <div id="baseinfo2021713">
    <el-form ref="householderRoomInfo" :model="query" label-width="100px" margin-top = "0" >
      <el-col :span="5">
        <el-form-item label="房型">
          <el-select v-model="householderRoomInfo.roomLayout" placeholder="" style="width: 100%;" clearable disabled>
             <el-option
                style="padding-left: 10px;"
                v-for="item in roomLayout"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="房屋类型">
          <el-select v-model="householderRoomInfo.roomType" placeholder="" style="width: 100%;" clearable disabled>
             <el-option
                style="padding-left: 10px;"
                v-for="item in roomType"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
   
      <el-col :span="5">
        <el-form-item label="房屋状态">
            <el-select v-model="householderRoomInfo.roomStatus" placeholder="" style="width: 100%;" clearable disabled>
             <el-option
                style="padding-left: 10px;"
                v-for="item in roomStatus"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="5">
        <el-form-item label="建筑面积">
            <el-input v-model="householderRoomInfo.floorage " placeholder="" disabled></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="5">
        <el-form-item label="使用面积">
          <el-input v-model="householderRoomInfo.usableArea " placeholder="" disabled></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="5">
        <el-form-item label="朝向">
            <el-select v-model="householderRoomInfo.roomOrientations" placeholder="" style="width: 100%;" clearable disabled>
             <el-option
                style="padding-left: 10px;"
                v-for="item in roomOrientations"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-form>
     
    <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   v-model="form"
                   ref="crud"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >    
    </avue-crud>
      
    </div>
</template>

<script>
  import {
  getBillSearch,getSubjectList,getHouseholderInfo
} from '@/api/charge/charge-pay';
import { getDictionary } from '../../../api/common';
    export default {
        props:{
            householderRoomInfo:{},
        },
         data() {
        return {
            loading: true,
            query: {
            propertyId:''
            },
            form:{},
            data:[],
            option:{
                    height: '500',
                    calcHeight: 500,
                    tip: false,
                    border: true,
                    index: true,
                    indexLabel: "序号",
                    addBtn:false,
                    viewBtn: false,
                    selection: false,
                    menu:false,
                     column:[
                         {
                                    label: "人员名称",
                                    prop: "householdName",
                                   
                                   
                        },
                         {
                                    label: "人员类型",
                                    prop: "householdType",
                                    type:'select',
                                    dataType:'string',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    dicUrl:'/api/blade-system/dict/dictionary?code=household_type'
                                   
                        },
                         {
                                   label: "性别",
                                    prop: "sex",
                                    type:"select",
                                    dicData:[
                                    {
                                      label:'女',
                                      value:2
                                    },{
                                      label:'男',
                                      value:1
                                    }
                                  ]
                                   
                        },
                         {
                                    label: "联系电话",
                                    prop: "linkPhone",
                                   
                        },
                          {
                                    label: "身份证",
                                    prop: "idCard",
                                   
                        },
                        {
                                    label: "邮箱",
                                    prop: "email",
                                   
                        },
                        {
                                    label: "QQ",
                                    prop: "qq",
                                   
                        },  
                     ]
            },
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            roomOrientations:[],//房屋朝向
            roomStatus:[],//房屋状态
            roomType:[],//房屋类型
            roomLayout:[],//户型
           
        }
      },
     mounted() {
      this.initSelectList()
      console.log("房屋信息",this.householderRoomInfo)
     },
     methods:{
       //表格清空
        restTable(){
          //数据清空
          this.data = []
          //分页清空
          this.page.total = 0  
        },
         search(val){
             this.query.propertyId = val
             this.onLoad();
         },
        currentChange(currentPage) {
                this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        onLoad(page) {
            page = page || this.page;
            this.loading = true;
            getHouseholderInfo(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              console.log("基础人员信息",data)
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
            })
            this.loading = false;
        },
        //字典查询
        initSelectList() {
            //房屋朝向
            getDictionary('room_orientations').then((data) => {
                this.roomOrientations = data.data;
            });
            //房屋类型
            getDictionary('room_type').then((data) => {
                this.roomType = data.data;
            });
            //房屋状态
            getDictionary('room_status').then((data) => {
                this.roomStatus = data.data;
            });
            //房型
            getDictionary('room_layout').then((data) => {
                this.roomLayout = data.data;
            });
        },
     }
    }
  </script>
<style>
#baseinfo2021713 .el-input__icon{
  line-height: 32px
}
</style>

<style scoped >

</style>